import {Box, Col, Row} from 'components/Grid';
import {Typography} from 'components/Typography';
import {BrandAlphabet} from 'modules/brands/components/BrandAlphabet';
import {useState} from 'react';
import {TBrandAlphabetLetter} from 'modules/brands/types';
import BrandCatalog from 'modules/brands/components/BrandCatalog';
import style from './style.module.scss';
import {Breadcrumbs} from 'modules/breadcrumbs/components/Breadcrumbs';
import {BRAND_ALPHABET} from 'modules/brands/constants';
import {IBreadcrumb} from 'modules/seo/types';

interface IProps {
    breadcrumbs?: IBreadcrumb[];
}

export const BrandsListingPage = ({breadcrumbs = []}: IProps) => {
    const [selectedLetter, setSelectedLetter] = useState<TBrandAlphabetLetter>(BRAND_ALPHABET[0]);

    return (
        <>
            <Box>
                <Breadcrumbs breadcrumbs={breadcrumbs} />
            </Box>
            <Box>
                <Row className={style.container}>
                    <Col lg={11} md={12} sm={12}>
                        <div className={style.brandsListingPage}>
                            <div className={style.titleWrap}>
                                <div className={style.underline}></div>
                                <Typography className={style.title} element={'h1'} variant={'display-42-reg'}>
                                    Бренды
                                </Typography>
                            </div>
                        </div>
                        <BrandAlphabet
                            className={style.brandAlphabet}
                            currentCode={selectedLetter?.filteredCode}
                            onChange={setSelectedLetter}
                        />
                        <BrandCatalog selectedLetter={selectedLetter} />
                    </Col>
                </Row>
            </Box>
        </>
    );
};
